// Nothing changes when a style's font cannot be loaded; say so rather than fail silently.
export const FONT_FAILED_TOAST_KEY = 'editor-indesign-import-fonts-missing';
